import { createContext, useContext } from 'react';
import { useSearchController } from '@controllers/useSearchController';

const SearchContext = createContext(null);

export function SearchProvider({ children }) {
  const value = useSearchController();

  return (
    <SearchContext.Provider value={value}>
      {children}
    </SearchContext.Provider>
  );
}

export function useSearch() {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('useSearch must be used within SearchProvider');
  }
  return context;
}
